var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 19.0602V17.1566H5.69594V10.1446C5.69594 8.71486 6.1195 7.43373 6.96662 6.3012C7.81374 5.16867 8.94461 4.4498 10.3592 4.14458V3.51807C10.3592 3.08434 10.5196 2.72289 10.8403 2.43373C11.1611 2.14458 11.5435 2 11.9877 2C12.4318 2 12.8142 2.14458 13.135 2.43373C13.4557 2.72289 13.6161 3.08434 13.6161 3.51807V4.14458C15.0307 4.4498 16.1698 5.16867 17.0334 6.3012C17.897 7.43373 18.3287 8.71486 18.3287 10.1446V17.1566H21V19.0602H3ZM11.9877 22C11.4284 22 10.939 21.7992 10.5196 21.3976C10.1001 20.996 9.89042 20.5221 9.89042 19.9759H14.0849C14.0849 20.5382 13.8793 21.0161 13.4681 21.4096C13.0568 21.8032 12.5634 22 11.9877 22ZM7.64514 17.1566H16.3549V10.1446C16.3549 8.95582 15.9354 7.94378 15.0965 7.10843C14.2576 6.27309 13.2296 5.85542 12.0123 5.85542C10.7951 5.85542 9.76294 6.27309 8.91582 7.10843C8.0687 7.94378 7.64514 8.95582 7.64514 10.1446V17.1566Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1e366142.svg";
export { ForwardRef as ReactComponent };